import type { AppMixedType } from '~/types/app.d';

/**
 * 评分数字展示
 */
export const showScore = (number: string | number) => {
  number = Number(number);
  if (number === 10) {
    return number;
  } else {
    // 浮点型
    return number.toFixed(1);
  }
};

export const getModuleValueFromData = (
  app: AppMixedType | undefined | null,
  /** 需要从 app show_module 取出来的值 */
  key: string,
  /** @defaultValue true 取不到时的默认值 */
  defaultValue = true,
) => {
  if (!app) {
    return defaultValue;
  }
  if ('show_module' in app && Array.isArray(app.show_module)) {
    return app.show_module.filter((module) => module.key === key)?.[0]?.value ?? defaultValue;
  }
  return defaultValue;
};

/**
 * 无评分展示
 */
export const getAppRating = (rating: string | number) => {
  if (`${rating}` === '0' || !rating) {
    return '';
  }
  return rating;
};
